"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APCard = void 0;
var react_1 = __importDefault(require("react"));
function APCard(props) {
    var _a;
    var mStyle = __assign({ borderRadius: "25px", display: "flex", flexDirection: "column", background: "#fff", padding: (_a = props.padding) !== null && _a !== void 0 ? _a : "24px 20px", height: props.height, width: props.width }, props.style);
    return (react_1.default.createElement("div", { style: mStyle }, props.children));
}
exports.APCard = APCard;
